import { render, staticRenderFns } from "./PoljeUnosaIzbor.vue?vue&type=template&id=50c5d280&scoped=true"
import script from "./PoljeUnosaIzbor.vue?vue&type=script&lang=js"
export * from "./PoljeUnosaIzbor.vue?vue&type=script&lang=js"
import style0 from "./PoljeUnosaIzbor.vue?vue&type=style&index=0&id=50c5d280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5d280",
  null
  
)

export default component.exports